const { __ } = wp.i18n;
export default [
  {
    label: __("Linear", "uipress-lite"),
    value: "linear",
  },
  {
    label: __("Ease", "uipress-lite"),
    value: "ease",
  },
  {
    label: __("Ease in", "uipress-lite"),
    value: "ease-in",
  },
  {
    label: __("Ease in out", "uipress-lite"),
    value: "ease-in-out",
  },
  {
    label: __("Ease out", "uipress-lite"),
    value: "ease-out",
  },
  {
    label: __("Out sine", "uipress-lite"),
    value: "cubic-bezier(0.39, 0.58, 0.57, 1)",
  },
  {
    label: __("Out quadratic", "uipress-lite"),
    value: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
  },
  {
    label: __("Back out", "uipress-lite"),
    value: "cubic-bezier(0.18, 0.89, 0.32, 1.28)",
  },
];
